import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TransactionType } from '@shared/helpers/enums/transaction-type';
import { Security } from '@shared/models/security';

@Component({
  standalone: false,
  selector: 'gstar-tax-result-security-details',
  templateUrl: './tax-result-security-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaxResultSecurityDetailsComponent {
  @Input()
  security!: Security;
  transactionTypes = TransactionType;
}
